(() => {
  const attributes = [
    '[data-price-rrp]',
    '[data-price-original]',
    '[data-price-compare]',
    '[data-price-compare-min]',
    '[data-price-compare-max]',
    '[data-price]',
    '[data-sale-price]',
    '[data-price-min]',
    '[data-price-max]',
    '[data-cart-total]',
    '[data-cartitem-total]',
    '[bss-b2b-product-price]',
    '.bss-b2b-customized-compare-at-price'
  ];
  const selectors = '' + attributes.join(',');
  const cachedPrices = {
    addonVariants: null,
    productVariants: null
  };
  

  // '[bss-b2b-final-line-price]',
  // '[bss-b2b-cart-total-price]',
  
  const strings = {
    //included: window.languages.tax.included || 'inc. VAT',
    //excluded: window.languages.tax.excluded || 'ex. VAT',
    included: '',
    excluded: '',
  };

  function getVat() {
    return (localStorage.getItem('vat') || true).toString() === 'true';
  }

  function showVat() {
    if (!getVat()) {
      localStorage.setItem('vat', true);
      updatePrices();
      updateGPOConfig();
      setGPOdata();
    }
  }

  function hideVat() {
    if (getVat()) {
      localStorage.setItem('vat', false);
      updatePrices();
      updateGPOConfig();
      setGPOdata();
    }
  }

  function toggleVat() {
    localStorage.setItem('vat', !getVat());
    updatePrices();
  }

  function setAttributes(el, force=false, price=false, adjustment=null) {
    if (!el.hasAttribute('data-ex') || force) {
      if (!price) price = el.textContent.trim().split(' ')[0];
      price = price.replace(/,/g, '');
      if (price.indexOf('.') === -1) return;
      
      // Get the original raw price
      let originalRaw = price.match(/[0-9]+\.[0-9]{2}/)[0];
      let raw = Number(originalRaw).toFixed(2);
  
      // Apply adjustment if provided
      if (adjustment !== null) {
        raw = (Number.parseFloat(raw) + adjustment).toFixed(2);
      }
      
      /*
      // When prices are ex. VAT
      const inc = (raw * 1.2).toFixed(2);
      el.dataset.ex = price.trim();
      el.dataset.inc = price.replace(originalRaw, inc).trim();
      */
      
      // When prices are inc. VAT
      const ex = (raw / 120 * 100).toFixed(2);
      el.dataset.ex = ex;
      el.dataset.inc = raw;
    }
  }
  
  function updatePrice(el) {
    if (!el.dataset.inc || !el.dataset.ex) return;
    
    const attributes = Array.from(el.attributes).map(n => n.name).toString();
    const formattedInc = Number(el.dataset.inc).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const formattedEx = Number(el.dataset.ex).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
    const numberPattern = /[-+]?\d{1,3}(?:,\d{3})*(\.\d{1,2})?/g;

    if (getVat()) {
      el.textContent = el.textContent.replace(numberPattern, match => formattedInc) +
        (attributes.indexOf('-min') === -1 && attributes.indexOf('rrp') === -1 ? ' ' + strings.included : '');
    } else {
      el.textContent = el.textContent.replace(numberPattern, match => formattedEx) +
        (attributes.indexOf('-min') === -1 && attributes.indexOf('rrp') === -1 ? ' ' + strings.excluded : '');
    }
  }
  
  function updateOptionPrice(el) {
    if (!el.dataset.inc || !el.dataset.ex) return;
    const attributes = Array.from(el.attributes).map(n => n.name).toString();
    let text = el.textContent.split('(')[0];
    if (getVat()) {
      el.textContent = text + ' (£' + el.dataset.inc + ')';
    } else {
      el.textContent = text + ' (£' + el.dataset.ex + ')';
    }
  }
  
  function updatePrices() {
    document.querySelectorAll(selectors).forEach(el => updatePrice(el));
  }

  function listenToGPOChanges() {
    const gpoInputElements = document.querySelectorAll('.gpo-container .gpo-app input[type="radio"]');
    gpoInputElements.forEach(el => {
      el.addEventListener('change', (e) => {
        setTimeout(() => {
          const priceElements = document.querySelectorAll('.product-main .product-details [data-gpo-product-unit-price], .product-main .product-details [data-gpo-product-unit-price]')
          priceElements.forEach(el => {
            if(!el || el.textContent.trim() === '') return;
            const priceText = el.textContent.trim().split(' ')[0];
            const priceValue = Number(priceText.replace(/[^0-9.-]+/g, ''));

            // Calculate percentage adjustment based on VAT status
            // If getVat() is true, no adjustment (0%)
            // If getVat() is false, adjust by 20% (VAT amount)
            const percentageAdjustment = getVat() ? 0 : (priceValue * 0.2);
            setAttributes(el, true, false, percentageAdjustment);
            updatePrice(el);
          });

          const gpoLabelEl = document.querySelector('.gpo-container .gpo-app .gpo-label .addOn')
          if(gpoLabelEl) {
            const priceText = gpoLabelEl.textContent.trim();
            const priceValue = Number(priceText.match(/[-+]?\d+\.\d{2}/));

            // Calculate percentage adjustment based on VAT status
            // If getVat() is true, no adjustment (0%)
            // If getVat() is false, adjust by 20% (VAT amount)
            const percentageAdjustment = getVat() ? 0 : (priceValue * 0.2);
            setAttributes(gpoLabelEl, true, priceText, percentageAdjustment);
          }

        }, 500)
      });
    });
  }

  function updateGPOConfig() {
    // Check if the required objects exist
    if(!window.GPOConfigs || 
       !window.GPOConfigs.addonVariants || 
       !window.GPOConfigs.product || 
       !window.GPOConfigs.product.variants) {
      return false;
    }

    // WARNING - EXTREMELY RISKY
    // Store original prices in cache if not already stored
    if (!cachedPrices.addonVariants) {
      cachedPrices.addonVariants = window.GPOConfigs.addonVariants.map(variant => ({
        id: variant.id,
        price: variant.price
      }));
    }
    
    if (!cachedPrices.productVariants) {
      cachedPrices.productVariants = window.GPOConfigs.product.variants.map(variant => ({
        id: variant.id,
        price: variant.price
      }));
    }

    const isVatIncluded = getVat();
    
    // Helper function to update prices for a collection of variants
    const updatePrices = (variants, cachedCollection) => {
      return variants.map(variant => {
        if (isVatIncluded) {
          // Restore original price from cache
          const cachedVariant = cachedCollection.find(cached => cached.id === variant.id);
          return {
            ...variant,
            price: cachedVariant ? cachedVariant.price : variant.price
          };
        } else {
          // Update price to exclude VAT
          return {
            ...variant,
            price: Math.round((variant.price / 120) * 100 * 100) / 100
          };
        }
      });
    };

    // Update both collections using the helper function
    window.GPOConfigs.addonVariants = updatePrices(window.GPOConfigs.addonVariants, cachedPrices.addonVariants);
    window.GPOConfigs.product.variants = updatePrices(window.GPOConfigs.product.variants, cachedPrices.productVariants);
    
    return true;
  }

  function setGPOdata() {
    setTimeout(() => {
      document.querySelectorAll('.gpo-container .gpo-app .addOn').forEach(el => {
        let price = el.textContent.match(/([0-9]+\.[0-9]{2})/);
        if (price && price.length > 1) {
          setAttributes(el, false, price[1]);
          updateOptionPrice(el);
        }
      });
    }, 1000);
  }

  window.addEventListener('DOMContentLoaded', () => {
    // Create an interval that will check for GPOConfigs every second
    if (!document.querySelector('.gpo-product-variants')) {
      console.log('No GPO app found on page, skipping GPOConfigs checks');
    } else {
      // Create an interval that will check for GPOConfigs with a 1-minute timeout
      let gpoConfigInterval;
      let startTime = Date.now();
      let logCounter = 0;
      
      gpoConfigInterval = setInterval(() => {
        // Only log every 10 seconds (every 10th iteration with a 1-second interval)
        if (logCounter % 10 === 0) {
          console.log('Checking for GPOConfigs...');
        }
        logCounter++;
        
        // Check if we've been trying for more than a minute
        if (Date.now() - startTime > 10000) {
          console.log('GPOConfigs check timed out after 10 seconds');
          clearInterval(gpoConfigInterval);
          return;
        }
        
        if(updateGPOConfig()) {
          // GPOConfigs found and updated, clear the interval
          console.log('GPOConfigs found and updated, clearing interval');
          clearInterval(gpoConfigInterval);
        }
      }, 1000);
    }

    setTimeout(() => {
      document.querySelectorAll(selectors).forEach(el => setAttributes(el));

      // document.addEventListener('globo.options.event.product.price.updated', (evt) => {
      //   document.querySelectorAll('[data-gpo-product-compare-at-price],[data-gpo-product-unit-price]').forEach(el => {
      //     if (el.textContent.indexOf('VAT') === -1) {
      //       setAttributes(el, true);
      //       updatePrice(el);
      //     }
      //   });
      // });

      document.querySelectorAll('[data-vat-toggle]').forEach(el => {
        el.checked = getVat();
        el.addEventListener('change', () => {
          el.checked ? showVat() : hideVat();
        });
      });


      updatePrices();
      listenToGPOChanges();
      setGPOdata();
      
      document.addEventListener('variantChanged', updatePrices);
      document.addEventListener('bss.b2b.vat.validateVatByBSS', updatePrices);

      const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach(m => {
          if (m.type === 'childList' && m.addedNodes.length > 0) {
            let shouldContinue = Array.from(m.addedNodes).some(node => 
              node.nodeType === 1 && (node.closest(selectors) || node.querySelector(selectors))
            );
      
            if (!shouldContinue) return;

            m.target.querySelectorAll(selectors).forEach(el => {
              setAttributes(el);
              updatePrice(el);
            });
            m.target.querySelectorAll('.gpo-container .gpo-app .addOn').forEach(el => {
              setTimeout(() => {
                let price = el.textContent.match(/([0-9]+\.[0-9]{2})/);
                if (price && price.length > 1) {
                  setAttributes(el, false, price[1]);
                  updateOptionPrice(el);
                }
              }, 100);
            });
          }
        })
      });

      observer.observe(document.querySelector('body'), {
        characterData: false,
        childList: true,
        attributes: true,
        subtree: true,
      });
    }, 2000);
  });
})();